export default "__VITE_ASSET__DAOKAGfQ__"